/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {
  ColDef,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy
} from 'ag-grid-community';
import {DISMISS_MSG} from '../../../../common/constants';
import {AutocompleteFilterComponent} from '../../../../core/filters/autocomplete-filter/autocomplete-filter.component';
import {FcorgRegionMapModel} from '../../../../models/fcorg-region-map.model';
import {GfsUserService} from '../../../../services/gfs-user.service';

@Component({
    selector: 'app-view-user-map-popup',
    templateUrl: './view-user-map-popup.component.html',
    styleUrls: ['./view-user-map-popup.component.scss'],
    standalone: false
})
export class ViewUserMapPopupComponent implements OnInit {

  fcorgRegionMapData: FcorgRegionMapModel[] = [];
  fcorgRegionMapColumns: ColDef[] = [
    {field: 'fcorg', headerName: 'Global FCORG', filter: AutocompleteFilterComponent},
    {field: 'region', headerName: 'Region'}
  ];
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
    type: "fitGridWidth",
  };

  showSpinner = false;


  constructor(@Inject(MAT_DIALOG_DATA) public data: { userId: string },
              public dialogRef: MatDialogRef<ViewUserMapPopupComponent>,
              readonly snackbar: FabMessageService,
              private readonly gfsUserService: GfsUserService) {
  }

  ngOnInit(): void {
    this.loadUserMap();
  }

  /**
   * Fetches the user map from the user service
   */
  loadUserMap(): void {
    this.showSpinner = true;
    this.gfsUserService.getUserMap(this.data.userId).subscribe(
      (data) => {
        this.fcorgRegionMapData = data;
      },
      (error) => {
        this.showSpinner = false;
        this.snackbar.displayError(error, DISMISS_MSG);
      },
      () => {
        this.showSpinner = false;
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
